import { shortDate } from "./srUtil";
import { WatchVerdict, WatchFunds, WatchConditions, watchDetail } from "./EarningsWatch";
import { EdgeLadder } from "./EdgeLadder";

const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const TIMING = { amc: "after the close", bmo: "before the open" };
const countdown = (d) => (d === 0 ? "today" : d === 1 ? "tomorrow" : `in ${d} days`);

const NextDate = ({ n }) => (
  <div className="earndate" data-testid="sr-earnings-date">
    {n ? (
      <>
        <strong>{shortDate(n.date, true)}</strong>
        <span>{DAYS[new Date(`${n.date}T12:00:00Z`).getUTCDay()]} · {TIMING[n.timing] || "time not announced"}</span>
        <span className="countdown" data-testid="sr-earnings-countdown">{countdown(n.days)}</span>
      </>
    ) : <><strong className="muted">—</strong><span>No date announced yet</span></>}
  </div>
);

export const Earnings = ({ e, symbol, onDetail }) => {
  const w = e.watch;
  return (
    <div className="earningsbelow">
      <section className="card pad fadein" data-testid="sr-earnings">
        <span className="eyebrow">Earnings · next report</span>
        <div className="earnhead">
          <NextDate n={e.next} />
          {w && <WatchVerdict w={w} symbol={symbol} />}
        </div>
        {w?.conditions && (
          <div className="eagrid">
            <WatchConditions w={w} />
            {w.ladder ? <EdgeLadder w={w} symbol={symbol} /> : <div />}
          </div>
        )}
        {w?.funds && <WatchFunds w={w} symbol={symbol} />}
        {w?.record && <button className="textlink" onClick={() => onDetail(watchDetail(w))} data-testid="sr-earn-watch-detail">How the earnings signal works →</button>}
        <p className="smallnote">About how the stock tends to move on results day, not a forecast of a beat or a miss.</p>
      </section>
    </div>
  );
};
